const n = {
  name: "ChevronUpSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.9998 15.4144L11.9998 11.4144L7.99985 15.4144L6.58564 14.0002L11.9998 8.58594L17.4141 14.0002L15.9998 15.4144Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as ChevronUpSmall
};
